const viewBookingEN = {
	header: {
		eyebrow: "Your booking",
		title: "Booking Overview",
	},
	status: {
		confirmed: "Confirmed",
		cancelled: "Cancelled",
		completed: "Completed",
		in_progress: "In Progress",
		pending: "Pending",
		no_show: "No show",
		rescheduled: "Rescheduled",
	},
	details: {
		services: "Services",
		staff: "With",
		date: "Date",
		time: "Time",
		duration: "{{count}} min",
		total: "Total",
		location: "Location",
	},
	sidebar: {
		location: "Location",
		getDirections: "Get Directions",
	},
	manage: {
		title: "Manage booking",
		rescheduleInfo: "Need a different time, or can't make it any more?",
		rescheduleBtn: "Reschedule",
		cancelBtn: "Cancel booking",
		backBtn: "Back",
	},
	confirm: {
		title: "Cancel booking?",
		text: "This action cannot be undone. Are you sure you want to cancel this booking?",
		back: "Go back",
		confirm: "Yes, cancel",
	},
	reviewBlock: {
		yourReview: "Your review",
		edit: "Edit review",
		anonymous: "Anonymous",
		noComment: "No comment added.",
		ctaTitle: "How did it go?",
		ctaText: "Your rating helps other people find the good places — it only takes a moment.",
		ctaBtn: "Leave a review",
	},
	misc: {
		confirmationEmail: "A confirmation email was sent to",
		reviewSubmitted: "Thank you! Your review was submitted successfully.",
		reviewUpdated: "All set! Your review has been updated.",
	},
	errors: {
		load: "We couldn't load your booking. Please try again.",
		cancel: "We couldn't cancel your booking. Please try again.",
		reschedule: "We couldn't open rescheduling. Please try again.",
		reload: "We couldn't refresh your booking details.",
	},
};
export default viewBookingEN;
